export default "__VITE_ASSET__CY6Ug84D__"